(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/page-result/assets/react/result-page.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/page-result/assets/react/result-page.js');

'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _React = React,
  useEffect = _React.useEffect;
const _jotai = jotai,
  useAtomValue = _jotai.useAtomValue,
  useAtom = _jotai.useAtom;
const _svs$lyckoplatsen$com = svs.lyckoplatsen.components.shared_result.jotai.atoms,
  shouldShowIntervalAtom = _svs$lyckoplatsen$com.shouldShowIntervalAtom,
  correctionStepAtom = _svs$lyckoplatsen$com.correctionStepAtom,
  showFullscreenAtom = _svs$lyckoplatsen$com.showFullscreenAtom;
const isSelfService = svs.core.config.data.svsconfig.isSelfService;
const _svs$lyckoplatsen$com2 = svs.lyckoplatsen.components.page_result.react.components,
  DrawPicker = _svs$lyckoplatsen$com2.DrawPicker,
  Result = _svs$lyckoplatsen$com2.Result,
  ResultInterval = _svs$lyckoplatsen$com2.ResultInterval,
  ParamsFullscreen = _svs$lyckoplatsen$com2.ParamsFullscreen;
const ResultPage = () => {
  const shouldShowInterval = useAtomValue(shouldShowIntervalAtom);
  const _useAtom = useAtom(correctionStepAtom),
    _useAtom2 = _slicedToArray(_useAtom, 2),
    correctionStep = _useAtom2[0],
    setCorrectionStep = _useAtom2[1];
  const showFullscreen = useAtomValue(showFullscreenAtom);
  useEffect(() => {
    if (shouldShowInterval) {
      setCorrectionStep(4);
    }
  }, [shouldShowInterval, setCorrectionStep]);
  useEffect(() => {
    if (!svs.core.detect.os.iOS()) {
      return;
    }
    const preventZoom = e => e.preventDefault();
    document.addEventListener('gesturestart', preventZoom);
    return () => {
      document.removeEventListener('gesturestart', preventZoom);
    };
  }, []);
  return React.createElement("div", {
    className: "lp-page-result lp-page-grow lp-correction-step-".concat(correctionStep, " ").concat(correctionStep !== 4 && isSelfService ? 'lp-no-ss-bottom-margin' : '')
  }, showFullscreen && React.createElement(ParamsFullscreen, null), React.createElement(DrawPicker, null), shouldShowInterval ? React.createElement(ResultInterval, null) : React.createElement(Result, null));
};
Object.assign(svs.lyckoplatsen.components.page_result.react, {
  ResultPage
});

 })(window);